<app-colored-background [backgroundColor]="'#894AD9'">
  <app-header [progress]="1" [title]="locale.currentTranslation.informationHeader" [showProgressIndicator]="false"
              [useWhiteFontColor]="true" data-testid="what-is-covered-header"></app-header>
  <div>
    <div class="base-content-container" data-testid="what-is-covered-container">
      <div>
        <div class="headline1" style="color: #FFFFFF" data-testid="what-is-covered-title">
          {{ locale.currentTranslation.insuranceCovers }}
        </div>
        <div class="text-body1" style="color: #FFFFFF; margin-top: 8px;" data-testid="coverage-content">
          <ul data-testid="coverage-list">
            <li data-testid="coverage-item-1">{{ locale.currentTranslation.insuranceCoversBullet1 }}</li>
            <li data-testid="coverage-item-2">{{ locale.currentTranslation.insuranceCoversBullet2 }}</li>
            <li data-testid="coverage-item-3">{{ locale.currentTranslation.insuranceCoversBullet3 }}</li>
          </ul>
        </div>
      </div>
    </div>
    <app-finish-box data-testid="finish-box"></app-finish-box>
    <div class="main-button-spacing">
      <button class="main-button" routerLink="/claim-report-duty" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer data-testid="what-is-covered-footer"></app-footer>
</app-colored-background>
